import { Nullish } from "utility-types";
import { isEmpty } from "lodash";
import { IProject } from "../shared/db";

export interface ProjectContent extends Partial<
  Pick<IProject, "name" | "investigator" | "organization" | "description">
> {
  contactValue?: string;
  instructionValue?: string;
}

/**
 * Get fields that are not empty in project content and whose values are different from project
 */
export const getProjectContentDiffWithProject = ({
  projectContent,
  project,
}: {
  projectContent: Partial<ProjectContent> | Nullish;
  project: Partial<IProject> | Nullish;
}): Partial<ProjectContent> => {
  const diff: Partial<ProjectContent> = {};
  if (projectContent) {
    if (!isEmpty(projectContent.name) && projectContent.name !== project?.name) {
      diff.name = projectContent.name;
    }
    if (
      !isEmpty(projectContent.investigator) &&
      projectContent.investigator !== project?.investigator
    ) {
      diff.investigator = projectContent.investigator;
    }
    if (
      !isEmpty(projectContent.organization) &&
      projectContent.organization !== project?.organization
    ) {
      diff.organization = projectContent.organization;
    }
    if (
      !isEmpty(projectContent.description) &&
      projectContent.description !== project?.description
    ) {
      diff.description = projectContent.description;
    }
    if (
      !isEmpty(projectContent.contactValue) &&
      projectContent.contactValue !== project?.contactDescription
    ) {
      diff.contactValue = projectContent.contactValue;
    }
    if (
      !isEmpty(projectContent.instructionValue) &&
      projectContent.instructionValue !== project?.participantInstructions
    ) {
      diff.instructionValue = projectContent.instructionValue;
    }
  }
  return diff;
};

/**
 * Get fields that are not empty in project and empty in project content
 */
export const getUpdatesForProjectContentFromProject = ({
  project,
  projectContent,
}: {
  project: Partial<IProject> | Nullish;
  projectContent: Partial<ProjectContent> | Nullish;
}): Partial<ProjectContent> => {
  const diff: Partial<ProjectContent> = {};
  if (project) {
    if (!isEmpty(project.name) && isEmpty(projectContent?.name)) {
      diff.name = project.name;
    }
    if (!isEmpty(project.description) && isEmpty(projectContent?.description)) {
      diff.description = project.description;
    }
    if (!isEmpty(project.investigator) && isEmpty(projectContent?.investigator)) {
      diff.investigator = project.investigator;
    }
    if (!isEmpty(project.organization) && isEmpty(projectContent?.organization)) {
      diff.organization = project.organization;
    }
    if (!isEmpty(project.participantInstructions) && isEmpty(projectContent?.instructionValue)) {
      diff.instructionValue = project.participantInstructions;
    }
    if (!isEmpty(project.contactDescription) && isEmpty(projectContent?.contactValue)) {
      diff.contactValue = project.contactDescription;
    }
  }
  return diff;
};
